let cachedTranslations;
let cachedLocal;
const untranslated = [];
import getAppState from 'app-state';

declare global {
  interface Window {
    rcmI18nTranslations: {
      defaultLocale: string;
      translations: { [key: string]: string };
    };
  }
}

const TAG_OPEN = '{';
const TAG_CLOSE = '}';

/**
 * @todo Variable support doesn't currently work for all translations, as some
 *       use a different method of substitution other than {brackets}
 * @param message
 * @param vars
 */
export function translate(
  message: string,
  vars: { [key: string]: any } = {}
): string {
  const translations = getAllTranslations();
  let translation: string;
  if (!(message in translations)) {
    if (!untranslated.includes(message)) {
      // tslint:disable-next-line:no-console
      console.warn(
        'Translation not found for message "' +
          message +
          '". Using un-translated message as-is.'
      );
      untranslated.push(message); // Prevent repeat warnings from flooding dev console
    }
    translation = message;
  } else {
    translation = translations[message];
  }
  // tslint:disable-next-line:forin
  for (const key in vars) {
    translation = translation.replace(TAG_OPEN + key + TAG_CLOSE, vars[key]);
  }
  return translation;
}

export function getLocale(): string {
  if (!cachedLocal) {
    cachedLocal = getAppState('rcmi18n.defaultLocale');
  }
  return cachedLocal;
}

export function getAllTranslations() {
  if (!cachedTranslations) {
    cachedTranslations = getAppState('rcmi18n.translations')[getLocale()];
  }
  return cachedTranslations;
}

/**
 * Compare two strings with respect to the current locale.
 */
export function strLocaleCompare(a: string, b: string) {
  return a.localeCompare(b, _localeFmt);
}
const _localeFmt = getLocale().replace('_', '-');
